define(["require", "exports", "UI/FileUploader", "UI/StatusIndicator", "custom-imprinting/Trademark", "UI/Context"], function (require, exports, FileUploader_1, StatusIndicator_1, Trademark_1, Context_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LogoUploadForm = void 0;
    class LogoUploadForm extends StatusIndicator_1.StatusIndicator {
        constructor(type, url) {
            super({
                Delay: 500,
                DefaultError: 'Your logo was not saved. Please try again. If this problem continues, please contact our Website Technical Assistance Team by calling 877-619-2174.'
            });
            this.AddUrl = '/myaccount/logomanager/addlogo';
            this.AcceptedTypes = '.png,.jpg,.jpeg,.gif,.webp,.tiff,.bmp,.svg,.eps,.ai,.psd,.indd,.cdr,.pdf';
            this.Cancel = () => {
                this.ResetForm();
            };
            this.Edit = (trademark, url) => {
                this.initializeMode(trademark, this.Editing);
                this.Url(url);
            };
            this.Delete = (trademark, url) => {
                this.initializeMode(trademark, this.Deleting);
                this.Url(url);
            };
            this.initializeMode = (trademark, mode) => {
                mode(true);
                this.Reset();
                this.Trademark(trademark);
            };
            this.loadTrademarkData = (trademark) => {
                if (trademark) {
                    this.Name(trademark.Name());
                    this.Description(trademark.Description());
                    this.ImagePath(trademark.ImagePath());
                }
            };
            this.HandleSubmit = (data, event) => {
                if (this.GetStatus() === StatusIndicator_1.Status.Loading) {
                    return;
                }
                let payload = this.BuildPayload(data, this.Editing() || this.Deleting());
                this.SetStatus(StatusIndicator_1.Status.Loading);
                this.SendLogo(payload, this.Url());
            };
            this.handleError = response => {
                if (response.errors) {
                    this.Errors(response.errors);
                }
                Context_1.default.IsDev() && console.log("Error:", response);
                this.ClearFields();
                this.SetStatusAfterDelay(StatusIndicator_1.Status.Error);
            };
            this.Type = type || "";
            this.TypeId = this.Type.toLowerCase().replace(' ', '-');
            this.Url = ko.observable(url || this.AddUrl);
            this.Name = ko.observable('');
            this.Description = ko.observable('');
            this.ImagePath = ko.observable('');
            this.Trademark = ko.observable(null);
            this.Trademark.subscribe(this.loadTrademarkData);
            let uploaderOptions = {
                Id: this.Type.toLowerCase().replace(' ', '-') + 'logo-upload',
                Name: 'TrademarkLogo',
                AcceptedFileTypes: this.AcceptedTypes,
                AcceptsMultiple: false,
                ActionText: 'Upload a Logo',
                ButtonClass: 'sbtn-secondary'
            };
            this.FileUploader = new FileUploader_1.FileUploader(uploaderOptions);
            this.FileUpload = ko.computed(() => this.GetFile(this.FileUploader.FileList()));
            this.UploadedTrademark = ko.observable(null);
            this.Progress = ko.observable(0);
            this.Editing = ko.observable(false);
            this.Deleting = ko.observable(false);
            this.ShowForm = ko.computed(() => {
                return this.FileUploader.HasFiles() || ((this.Editing() || this.Deleting()) && this.Trademark() !== null);
            });
            this.FileUpload.subscribe(file => file && this.Name(file.name));
            this.FileUploader.HasFiles.subscribe(hasFiles => {
                if (hasFiles) {
                    this.Reset();
                }
            });
        }
        GetFile(list) {
            return list && list.length > 0 ? list[0] : null;
        }
        ResetForm() {
            this.ClearFields();
            this.Reset();
        }
        ClearFields() {
            this.Name('');
            this.Description('');
            this.ImagePath('');
            this.Trademark(null);
            this.UploadedTrademark(null);
            this.FileUploader.ClearFiles();
            this.Editing(false);
            this.Deleting(false);
            this.Url(this.AddUrl);
        }
        BuildPayload(form, excludeFile) {
            let data = new FormData(form);
            data.append("type", this.Type.replace("Imprinting", "Printing"));
            if (!excludeFile) {
                data.append("file", this.FileUpload());
            }
            return data;
        }
        SendLogo(payload, url) {
            $.ajax({
                url: url,
                type: 'POST',
                data: payload,
                contentType: false,
                processData: false,
                xhr: () => {
                    var xhr = $.ajaxSettings.xhr();
                    xhr.upload.onprogress = (e) => {
                        if (e.lengthComputable) {
                            let progress = e.loaded / e.total * 100;
                            this.Progress(progress);
                            Context_1.default.IsDev() && console.log(progress);
                        }
                    };
                    return xhr;
                }
            }).done((response) => {
                if (response.success && response.trademark) {
                    Context_1.default.IsDev() && console.log("Success:", response);
                    this.UploadedTrademark(this.Deleting() ? this.Trademark() : new Trademark_1.Trademark(response.trademark));
                    this.ClearFields();
                    this.SetStatusAfterDelay(StatusIndicator_1.Status.Success);
                }
                else {
                    this.handleError(response);
                }
            }).fail(this.handleError);
        }
    }
    exports.LogoUploadForm = LogoUploadForm;
});
//# sourceMappingURL=LogoUploader.js.map